"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvatarInitials = exports.censorInitials = void 0;
const censorInitials = (initials) => {
    if (initials?.toUpperCase() === 'SS') {
        return 'S';
    }
    return initials;
};
exports.censorInitials = censorInitials;
const getAvatarInitials = (name) => {
    if (name.startsWith('+')) {
        return name;
    }
    const names = name.split(' ');
    const firstInitial = names[0]?.charAt(0);
    const lastInitial = names.length > 1 ? names[names.length - 1]?.charAt(0) : '';
    return (0, exports.censorInitials)(`${firstInitial}${lastInitial}`);
};
exports.getAvatarInitials = getAvatarInitials;
//# sourceMappingURL=AvatarUtil.js.map